export const validationMessageLocale = {
    mixed: {
        default: "This is a required field",
        required: "This is a required field",
    },
    string: {
        required: "This is a required field",
    },
};
